import * as React from "react";

function MatrixTable(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="#E7212B" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 9H21M10 9V20" stroke="#E7212B" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="14" cy="12.5" r="1" fill="#E7212B" />
      <circle cx="18" cy="16.5" r="1" fill="#E7212B" />
    </svg>
  );
}

export default MatrixTable;
